import styled from 'styled-components'

export const OptionsContainer = styled.div`
  overflow: auto;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    height: 424px;
  }
`

export const LoaderContainer = styled.div`
  text-align: center;
  padding: 100px 0;
`
